import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor() { }

  /**
   * Get token from localStorage
   */
  getToken(): string | null {
    try {
      const ids_loggedin_token_data = localStorage.getItem('ids_loggedin_token');
      if (!ids_loggedin_token_data) return null;

      // Handle both string and object formats
      const parsedToken = JSON.parse(ids_loggedin_token_data);
      return typeof parsedToken === 'string' ? parsedToken : parsedToken.access_token || parsedToken;
    } catch {
      return localStorage.getItem('ids_loggedin_token');
    }
  }

  /**
   * Check if token is valid (basic format check and expiration)
   */
  isTokenValid(): boolean {
    const token = this.getToken();
    if (!token) return false;

    try {
      // Basic JWT format validation
      const tokenParts = token.split('.');
      if (tokenParts.length !== 3) return false;

      // Check expiration
      const payload = JSON.parse(atob(tokenParts[1]));
      if (payload.exp) {
        const currentTime = Math.floor(Date.now() / 1000);
        return payload.exp > currentTime;
      }
      
      return true; // If no expiration, assume valid
    } catch {
      return false;
    }
  }

  /**
   * Check if token exists in localStorage
   */
  hasToken(): boolean {
    return !!this.getToken();
  }

  /**
   * Clear token from localStorage
   */
  clearToken(): void {
    localStorage.removeItem('ids_loggedin_token');
    localStorage.removeItem('userProfile'); // Remove any cached profile data
  }

  /**
   * Store token in localStorage
   */
  setToken(token: string): void {
    localStorage.setItem('ids_loggedin_token', JSON.stringify(token));
  }
}